import { render, staticRenderFns } from "./BenefitTypeEdit.vue?vue&type=template&id=38c80f41&scoped=true"
import script from "./BenefitTypeEdit.vue?vue&type=script&lang=js"
export * from "./BenefitTypeEdit.vue?vue&type=script&lang=js"
import style0 from "./BenefitTypeEdit.vue?vue&type=style&index=0&id=38c80f41&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c80f41",
  null
  
)

export default component.exports